import { useEffect } from "react";
import { SITE_URL } from "@/data/clinic";

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export default function Seo({ title, description, path = "/", jsonLd }) {
    const jsonKey = jsonLd ? JSON.stringify(jsonLd) : "";
    useEffect(() => {
        document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", `${SITE_URL}${path}`);
        let script;
        if (jsonLd) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.text = jsonKey;
            document.head.appendChild(script);
        }
        return () => {
            if (script) script.remove();
        };
    }, [title, description, path, jsonKey]);
    return null;
}
